var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxForm',{attrs:{"id":"formDate","col-count":1}},[_c('DxSimpleItem',{attrs:{"data-field":"date","name":"date","editor-type":"dxDateBox","caption":_vm.$t('DxSelectDate_date_caption'),"editor-options":{
      value: _vm.date,
      displayFormat: 'yyyy/MM/dd',
      onValueChanged: _vm.dateSelectedEvent,
      min: _vm.minDate,
      disabledDates:_vm.disableSundays,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }